'use client';

import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';
import type { DynamicPageData } from '@eliadmin/core/src/api/pages/pages-type';

import { ContactTab, type ContactTabProps } from './contact-tab';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlDescription } from '../ui/html-description';
import { BsEnvelope } from 'react-icons/bs';
import { CiMobile3 } from 'react-icons/ci';
import { BiMapPin } from 'react-icons/bi';
import { ContactPageForm } from './contact-page-form';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function ContactContent({
  generalLayout,
  content,
  page,
}: {
  generalLayout: GeneralLayout;
  content: string;
  page: DynamicPageData | null;
}) {
  const { t } = useTranslations();

  const iconStyle =
    'min-w-10 min-h-10 sm:min-w-12 sm:min-h-12 text-primary group-hover:text-secondary';

  const contacts = [
    {
      href: `mailto:${generalLayout.data.contact.email}`,
      label: 'E-mail',
      value: generalLayout.data.contact.email,
      icon: <BsEnvelope className={iconStyle} />,
    },
    {
      href: `tel:${generalLayout.data.contact.phone}`,
      label: t('text36'),
      value: generalLayout.data.contact.phone,
      icon: <CiMobile3 className={iconStyle} />,
    },
    {
      href: `tel:${page?.dynamic_data[0]?.value}`,
      label: t('text36'),
      value: page?.dynamic_data[0]?.value,
      icon: <CiMobile3 className={iconStyle} />,
    },
    {
      href: 'https://www.google.com/maps/place/Budat%C3%ADnska+3230%2F16,+851+04+Petr%C5%BEalka/@48.1032209,17.0978643,188m/data=!3m2!1e3!4b1!4m6!3m5!1s0x476c89bfc4252075:0x65f733b65da3dca7!8m2!3d48.10322!4d17.098508!16s%2Fg%2F11c22xps45?hl=sk-SK&entry=ttu&g_ep=EgoyMDI1MDYwNC4wIKXMDSoASAFQAw%3D%3D',
      label: 'Sídlo',
      value: `${generalLayout.data.contact.operationAddress}, ${generalLayout.data.contact.operationPostCode} ${generalLayout.data.contact.operationCity}`,
      icon: <BiMapPin className={iconStyle} />,
    },
  ] as ContactTabProps[];

  return (
    <div
      className={cn(
        'custom-container',
        'flex flex-col items-start justify-start gap-10 md:flex-row md:justify-between md:gap-12 lg:gap-16',
      )}
    >
      <div className="flex w-full max-w-[492px] flex-col items-start justify-start gap-10">
        {/* <p className="text-sm font-bold text-primary sm:text-base">
          Slovenská asociácia výrobcov a dodávateľov diagnostických zdravotníckych pomôcok „in
          vitro“ SEDMA, záujmové združenie právnických osôb
        </p> */}
        <HtmlDescription
          content={content}
          className="ea-contact-page-content w-full text-justify text-opacity-80"
          color="primary"
        />
        <div className="flex w-full flex-col items-start justify-start gap-5">
          {contacts.map(contact => (
            <ContactTab
              key={contact.label}
              href={contact.href}
              icon={contact.icon}
              value={contact.value}
              label={contact.label}
            />
          ))}
        </div>
        <div className="flex w-full flex-col gap-5">
          <div className="flex w-full flex-col gap-2">
            <p className="text-justify text-sm text-primary/80 sm:text-base">
              Slovenská asociácia výrobcov a dodávateľov diagnostických zdravotníckych pomôcok „in
              vitro“ SEDMA <br />
              <br />
              {generalLayout.data.contact.address} <br />
              {generalLayout.data.contact.postcode} {generalLayout.data.contact.city} <br />
              {generalLayout.data.contact.country?.name}
            </p>
            <p className="text-sm text-primary/80 sm:text-base">
              <strong>{t('text42')}:</strong>&nbsp;{generalLayout.data.contact.ico} <br />
              <strong>{t('text43')}:</strong>&nbsp;{generalLayout.data.contact.dic} <br />
            </p>
            <p className="text-sm text-primary/80 sm:text-base">
              <strong>IBAN:</strong>&nbsp;{generalLayout.data.contact.iban} <br />
              <strong>SWIFT:</strong>&nbsp;{generalLayout.data.contact.swift} <br />
            </p>
          </div>
        </div>
      </div>
      <div className="w-full md:max-w-[584px]">
        <ContactPageForm />
      </div>
    </div>
  );
}
